// Page header: red uppercase eyebrow, 26 px h1, muted lead and right-aligned actions; the one h1 of the page.
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface PageHeaderProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  lead?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ eyebrow, title, lead, actions, className }: PageHeaderProps) {
  return (
    <header className={cn("flex flex-wrap items-end justify-between gap-4", className)}>
      <div className="min-w-0">
        {eyebrow ? (
          <div className="text-label font-semibold tracking-eyebrow text-brand-text uppercase">{eyebrow}</div>
        ) : null}
        <h1 className="m-0 mt-1.5 text-h1 font-bold tracking-h1 text-foreground">{title}</h1>
        {lead ? <p className="m-0 mt-1.5 text-lead text-muted-foreground">{lead}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
